<template>
    <ul id="sortable">
        <draggable v-model="addedArticles.articles" @start="drag=true" @end="drag=false" @change="changed">
            <li class="ui-state-default" v-for="(element, index) in addedArticles.articles" :key="element.id">
				<a :href="element.url" target="_blank">{{element.title}}<span class="icon-link-arrow-right listCta__linkArrow"></span></a>
                <div class="sortableList__remove" v-on:click="removeArticle(index)">{{removeLabel}}</div>
            </li>
        </draggable>
    </ul>
</template>

<script>
	import draggable from 'vuedraggable';

    export default {
		name: "DraggableArticles",
        props: {
            addedArticles: {
                type: Object
			},
			removeLabel: {
				type: String,
				default: 'Remove'
			}
        },
        components: {
            draggable
		},
        methods: {
			changed() {
				this.$emit('update:articles', this.addedArticles);
			},
            removeArticle(index){
				this.addedArticles.articles.splice(index, 1);
				this.changed();
            }
        }
    };
</script>